import React from 'react';
import {
    Grid,
    Typography,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Hidden,
    ListItemSecondaryAction,
    Avatar,
} from '@material-ui/core';
import { Money } from '@paysera/money';
import Translator from '%app/js/common/services/translator';
import PropTypes from 'prop-types';
import cartShape from '%paysera_seat_selection_integration/js/seatings/propTypes/cartShape';
import { localizeMoney } from '%app/js/common/services/localizeMoney';
import CartItemList from '../CartItemList';

class Cart extends React.PureComponent {
    constructor(props) {
        super(props);

        this.handleSelectTicketTypeCount = this.handleSelectTicketTypeCount.bind(this);
        this.handleSelectPriceType = this.handleSelectPriceType.bind(this);
        this.handleRemoveCartItem = this.handleRemoveCartItem.bind(this);
    }

    handleSelectTicketTypeCount({ id, count }) {
        const { cart: { cart_items: cartItems }, updateCart } = this.props;

        const cartItem = cartItems.find(item => item.order_detail_id === id);
        if (!cartItem) {
            return;
        }

        updateCart({ id, cartItem: { ...cartItem, tickets_count: count } });
    }

    handleSelectPriceType({ id, hash }) {
        const { cart: { cart_items: cartItems }, updateCart } = this.props;

        const cartItem = cartItems.find(item => item.order_detail_id === id);
        if (!cartItem) {
            return;
        }

        updateCart({
            id,
            cartItem: {
                ...cartItem,
                price_type: {
                    ...cartItem.price_type,
                    hash,
                },
            },
        });
    }

    handleRemoveCartItem({ id }) {
        const { cart: { cart_items: cartItems }, discardReservation } = this.props;
        if (typeof cartItems.find(item => item.order_detail_id === id) === 'undefined') {
            return;
        }

        discardReservation({ id });
    }

    render() {
        const {
            cart: {
                cart_items: cartItems,
                original_price: originalPrice,
                discount_price: discountPrice,
                final_price: finalPrice,
            },
            classes: {
                paper,
                price,
                divider,
                icon,
                total,
            },
            seatsEnabled,
        } = this.props;

        const originalPriceMoney = new Money(originalPrice.amount, originalPrice.currency);
        const discountPriceMoney = new Money(discountPrice.amount, discountPrice.currency);
        const finalPriceMoney = new Money(finalPrice.amount, finalPrice.currency);

        return (
            <Paper className={paper}>
                <List>
                    <Hidden smDown>
                        <ListItem>
                            {seatsEnabled && (<ListItemAvatar><Avatar className={icon}>{' '}</Avatar></ListItemAvatar>)}
                            <ListItemText>
                                <Grid alignItems="center" container>
                                    <Grid xs={12} md={6} item>
                                        <Typography>
                                            {Translator.trans('seat_selection_integration.cart.ticket_type')}
                                        </Typography>
                                    </Grid>
                                    <Grid xs={12} md={5} item>
                                        <Typography>
                                            {Translator.trans('seat_selection_integration.cart.price')}
                                        </Typography>
                                    </Grid>
                                    <Grid xs={12} md={1} item>
                                        <Typography>
                                            {Translator.trans('seat_selection_integration.cart.count')}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </ListItemText>
                            <ListItemSecondaryAction />
                        </ListItem>
                    </Hidden>
                    <CartItemList
                        items={cartItems}
                        selectTicketTypeCount={this.handleSelectTicketTypeCount}
                        selectPriceType={this.handleSelectPriceType}
                        removeCartItem={this.handleRemoveCartItem}
                    />
                </List>
                <Divider className={divider} />
                <Grid alignItems="center" container id="cart-summary">
                    <Grid xs={12} className={total} item>
                        {!originalPriceMoney.isEqual(finalPriceMoney) && (
                            <Typography className={price} id="cart-original-price">
                                {Translator.trans(
                                    'seat_selection_integration.cart.original_price',
                                    { price: localizeMoney(originalPriceMoney) },
                                )}
                            </Typography>
                        )}
                        {!discountPriceMoney.isZero() && (
                            <Typography className={price} id="cart-discount-amount">
                                {Translator.trans(
                                    'seat_selection_integration.cart.discount_amount',
                                    { amount: localizeMoney(discountPriceMoney) },
                                )}
                            </Typography>
                        )}
                        <Typography className={price} id="cart-final-price">
                            {Translator.trans(
                                'seat_selection_integration.cart.final_price',
                                { price: localizeMoney(finalPriceMoney) },
                            )}
                        </Typography>
                    </Grid>
                </Grid>
            </Paper>
        );
    }
}

Cart.propTypes = {
    classes: PropTypes.shape({
        paper: PropTypes.string,
        price: PropTypes.string,
        divider: PropTypes.string,
        icon: PropTypes.string,
        total: PropTypes.string,
    }).isRequired,
    cart: PropTypes.shape(cartShape).isRequired,
    order: PropTypes.shape({
        token: PropTypes.string.isRequired,
    }).isRequired,
    seatsEnabled: PropTypes.bool.isRequired,
    updateCart: PropTypes.func.isRequired,
    discardReservation: PropTypes.func.isRequired,
};

export default Cart;
